import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../Button/Button'

import styles from './FormButtons.module.scss'
import classNames from 'classnames'

type FormButtonsProps = React.PropsWithChildren<{
  submitLabel?: string
  closeLabel?: string

  onSubmit?: () => void
  onClose?: () => void

  status?: any

  isSubmitting?: boolean
  isValid?: boolean

  extraClassName?: string
  showSubmit?: boolean
}>

export default React.memo(function FormButtons({
  submitLabel,
  closeLabel,
  onSubmit,
  onClose,
  status,
  isSubmitting,
  extraClassName,
  showSubmit = true,
}: FormButtonsProps) {
  const { t } = useTranslation()

  const submitType = onSubmit ? 'button' : 'submit'

  const statusText = useMemo(() => {
    if (!status) {
      return null
    }
    if (typeof status === 'string') {
      return status
    }
    if (status instanceof Error) {
      return status.message
    }
    return String(status)
  }, [status])

  return (
    <div className={classNames(styles.FormButtons, extraClassName)}>
      {showSubmit && (
        <Button type={submitType} onClick={onSubmit} filled disabled={isSubmitting} loading={isSubmitting}>
          {submitLabel || t('generic cta.save')}
        </Button>
      )}

      {onClose && (
        <Button onClick={onClose} disabled={isSubmitting}>
          {closeLabel || t('generic cta.cancel')}
        </Button>
      )}

      <div className={styles.submitError}>{statusText}</div>
    </div>
  )
})
